import { apiCall, ApiConfig } from '../../config/api'
import { getTypesPickingRouteAction } from '../actions/typePickingRouteActions'
import { call, put, takeEvery } from '@redux-saga/core/effects'
import { AxiosResponse, AxiosError } from 'axios'
import { TypePickingRoute } from '../../interfaces/PickingRoute/TypePickingRoute'
import { GET_TYPE_PICKING_ROUTE } from '../types/typePickingRouteActionsTypes'

export function* getTypesPickingRouteAsync() {
  try {
    const { status, data }: AxiosResponse<TypePickingRoute[]> = yield call(
      apiCall,
      'GET',
      `${ApiConfig.TypesPickingRouteApi}`
    )
    if (status === 200) {
      yield put(getTypesPickingRouteAction(data))
    }
  } catch (error) {
    const serverError = error as AxiosError<string>
    yield put(getTypesPickingRouteAction([], serverError.message))
  }
}

export function* watchGetTypesPickingRouteAsync() {
  yield takeEvery(GET_TYPE_PICKING_ROUTE, getTypesPickingRouteAsync)
}
